import React from "react";

const Navbar = () => (
	<nav className="bg-yellow-100 shadow-md sticky top-0 z-50">
		<div className="max-w-6xl mx-auto px-4 py-1 flex justify-between items-center">
			<div className="flex items-center space-x-4">
				<img src="./assets/lieuriche.png" alt="" className="w-[250px]" />
				{/* <h1 className="text-2xl font-bold text-white">Lieuriche Intl. Ltd.</h1> */}
			</div>
			<div className="space-x-6 text-black">
				<a href="#about" className="hover:underline">
					About
				</a>
				<a href="#services" className="hover:underline">
					Services
				</a>
				<a href="#contact" className="hover:underline">
					Contact
				</a>
			</div>
		</div>
	</nav>
);

export default Navbar;
